<template>
  <div>
    <div
      class="flexrow"
    >
      <a
        class="flexrow-item branch bullet"
        v-if="branch"
      >
        ┄
      </a>
      <template v-if="showExpand">
        <loader-icon
          class="flexrow-item icon bullet"
          v-if="loading"
        />
        <minus-square-icon
          class="flexrow-item icon bullet"
          @click="toggle()"
          v-else-if="expanded"
        />
        <plus-square-icon
          class="flexrow-item icon bullet"
          @click="toggle()"
          v-else
        />
      </template>
      <circle-icon
        v-else-if="branch"
        class="flexrow-item icon bullet"
        :name="iconName"
      />
      <div
        class="flexrow-item branchless bullet"
        v-else
      ></div>

      <kitsu-icon
        v-if="iconName !== ''"
        class="flexrow-item fancyicon"
        :name="iconName"
      />
      
      <p
        class=""
        :class="{
          bold: (!quiet && expanded) || bold,
          bright: (!quiet && expanded) || bright,
          'flexrow-item': true,
          'indent-title': true
        }"
        @click="$emit('title-click')"
      >
        {{ title }}
      </p>
    </div>
    <div
      v-if="showExpand"
      :class="{
        'indent-wrapper': branch,
        'indent-wrapper-branchless': !branch
      }"
    >
      <div
        class="indent-line"
        ref="noodle"
        v-if="expanded"
      >
      </div>
      <div
        class="indent"
        ref="indent"
        v-if="expanded"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import {
  LoaderIcon,
  CircleIcon,
  MinusSquareIcon,
  PlusSquareIcon
} from 'vue-feather-icons'
import KitsuIcon from '@/components/widgets/KitsuIcon'

export default {
  name: 'tree-indent',
  components: {
    LoaderIcon,
    CircleIcon,
    MinusSquareIcon,
    PlusSquareIcon,
    KitsuIcon
  },

  data() {
    return {
      expanded: false,
      showExpand: false,
      observer: null
    }
  },

  props: {
    title: {
      type: String,
      default: '---'
    },
    iconName: {
      type: String,
      default: ''
    },
    branch: {
      type: Boolean,
      default: true,
    },
    bold: {
      type: Boolean,
      default: false,
    },
    bright: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    expandable: {
      type: Boolean,
      default: true
    },
    forceExpand: {
      type: Boolean,
      default: null
    },
    quiet: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    updateExpandable () {
      this.showExpand = this.expandable && Object.keys(this.$slots || {}).length > 0
    },

    toggle () {
      console.log(this.$slots)
      if (this.forceExpand === null) {
        this.setExpand(this.expanded ? false : true)
      }
      this.$emit('icon-click')
    },

    setExpand (value) {
      if (this.expanded) {
        this.unobserve()
      }
      this.expanded = value
      this.$nextTick(() => {
        if (this.expanded) { this.observe() }
      })
    },

    setNoodleMargin () {
      var margin = 0
      if (this.expanded && this.$refs.indent && this.$refs.indent.children.length > 0) {
        margin = this.$refs.indent.lastChild.offsetHeight - 12
      }
      if (this.$refs.noodle) {
        this.$refs.noodle.style.marginBottom = margin + 'px'
      }
    },

    observe () {
      if (this.observer) { this.unobserve() }
      this.observer = new ResizeObserver(this.setNoodleMargin)
      this.observer.observe(this.$refs.indent)
    },

    unobserve () {
      if (this.observer) {
        this.observer.unobserve(this.$refs.indent)
        this.observer = null
      }
    }
  },

  watch: {
    forceExpand () {
      this.setExpand(this.forceExpand)
    },

    loading () {
      this.updateExpandable()
    },

    expandable () {
      this.updateExpandable()
    },

    $slots () {
      this.updateExpandable()
    }
  },

  mounted () {
    if (this.forceExpand) {
      this.expanded = true
    }
    if (this.expanded) {
      this.$nextTick(() => { this.observe() })
    }
    this.updateExpandable()
  },

  beforeDestroy () {
    if (this.expanded) { this.unobserve() }
  }
}
</script>
<style lang="scss" scoped>
// .branch {
//   margin-right: 2px;
//   cursor: pointer;
// }

p {
  font-size: 1.1em;
  cursor: pointer;
  text-wrap: nowrap;
}

// .icon {
//   margin-right: 2px;
//   margin-left: -3px;
//   scale: 70%;
//   cursor: pointer;
// }

.indent-title {
  color: $grey
}

.indent-line {
  border-left: 1px dotted;
  width: 0;
  max-width: 0;
  color: black;
}

// .bright {
//   color: $dark-grey;
// }

// .dark {
  .bright {
    color: $white-grey;
  }
  .indent-line {
    color: $white-grey;
  }
// }

.bold {
  font-weight: bold;
}

.branchless {
  margin-right: 2px;
  width: 14.7px;
}

.indent-wrapper {
  margin-left: 18px;
  padding-left: 0;
  display: flex;
}

.indent-wrapper-branchless {
  margin-left: 8px;
  padding-left: 0;
  display: flex;
}

.indent {
  margin-left: 0;
  padding-left: 0;
  flex: 1;
}

.fancyicon {
  margin: 0 4px 0 0;
  width: 18px;
}

.bullet {
  width: 13px;
  margin: 0 4px 0 0;
}
</style>
